
export * from './data/index';

import { synczbase } from '../lib/synczbase';
import { CalendarSettings, SaaSLandingContent, DEFAULT_SAAS_CONTENT } from '../types';

export const getCalendarSettings = async (): Promise<CalendarSettings> => {
    try {
        const snap = await synczbase.query("SELECT * FROM settings WHERE id = 'calendar' LIMIT 1");
        if (snap && snap.length > 0) {
            const row = snap[0];
            let dataObj = row.data;
            if (typeof dataObj === 'string') {
                try { dataObj = JSON.parse(dataObj); } catch (e) {}
            }
            if (dataObj && typeof dataObj === 'object') {
                return { enabled: false, phase: 'PHASE_1', ...dataObj };
            }
            return (row as unknown) as CalendarSettings;
        }
    } catch(e) {}
    return { enabled: false, phase: 'PHASE_1' };
};

export const updateCalendarSettings = async (settings: CalendarSettings) => {
    await synczbase.query(
        "INSERT INTO settings (id, data) VALUES ('calendar', $1) ON CONFLICT (id) DO UPDATE SET data = EXCLUDED.data",
        [JSON.stringify(settings)]
    );
};

export const getGoogleAuthUrl = async () => {
    return { url: '' };
};

export const linkGoogleCalendar = async (_code: string) => {
    return { success: false, email: '' };
};

export const listGoogleCalendars = async () => {
    const res = await synczbase.apiCall('/api/functions/listGoogleCalendars', 'POST');
    return res as { id: string, summary: string, primary: boolean }[];
};

export const retryCalendarSync = async (bookingId: string) => {
    await synczbase.apiCall('/api/functions/retryCalendarSync', 'POST', { bookingId });
};

export const fetchGoogleEvents = async (timeMin: string, timeMax: string) => {
    const res = await synczbase.apiCall('/api/functions/fetchGoogleEvents', 'POST', { timeMin, timeMax });
    return res as { events: any[] };
};

// --- SAAS LANDING PAGE CONTENT ---

export const getSaaSLandingContent = async (): Promise<SaaSLandingContent> => {
    try {
        const snap = await synczbase.query("SELECT * FROM settings WHERE id = 'saas_landing' LIMIT 1");
        if (snap && snap.length > 0) {
            const row = snap[0];
            let data = row.data;
            if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) {}
            }
            if (data && typeof data === 'object') {
                return { ...DEFAULT_SAAS_CONTENT, ...data };
            }
            return { ...DEFAULT_SAAS_CONTENT, ...row };
        }
    } catch (e) {
        console.warn("Failed to load SaaS content", e);
    }
    return DEFAULT_SAAS_CONTENT;
};

export const updateSaaSLandingContent = async (content: SaaSLandingContent) => {
    try {
        const snap = await synczbase.query("SELECT id FROM settings WHERE id = 'saas_landing'");
        const payloadStr = JSON.stringify(content);
        if (snap && snap.length > 0) {
            await synczbase.query("UPDATE settings SET data = $1 WHERE id = 'saas_landing'", [payloadStr]);
        } else {
            await synczbase.query(
                "INSERT INTO settings (id, data) VALUES ('saas_landing', $1)",
                [payloadStr]
            );
        }
    } catch (e) {
        console.error("Failed to update SaaS landing content:", e);
        throw e;
    }
};
